const initialState = {
  allTags: [],
  loading: true,
};

const tagsReducer = (state = initialState, action) => {
    switch (action.type) {
        case "GET_ALL_TAGS":
        console.log(action.loading,"actions")
      return {
        ...state,
        allTags: action.data,
        loading: action.loading,
      };

      case "GET_FILTERED_TAGS":
        return {
          ...state,
          allTags: action.data,
          loading: action.loading,
        };

    case "LOADING_DATA": {
      return { ...state, loading: true };
    }
    default:
      return state;
  }
};

export default tagsReducer;
